/* eslint-disable max-len */
// Пример тела POST-запроса, которое Overseer отправляет на URL вебхука при
// событиях инцидента. Ключи — snake_case, Content-Type: application/json.

export const WEBHOOK_PAYLOAD_EXAMPLE_GEO = `{
  "event": "incident.closed",
  "incident": {
    "id": 124,
    "created_at": "2026-06-12T10:00:00+00:00",
    "resolved_at": "2026-06-12T10:12:00+00:00",
    "duration_seconds": 720,
    "fail_locations_count": 2,
    "total_locations_count": 3,
    "locations": [
      { "name": "Москва, RU", "country": "RU", "city": "Москва", "status": "down", "code": 500, "message": "500 Internal Server Error", "time": 0, "ip": "1.2.3.4" },
      { "name": "Frankfurt, DE", "country": "DE", "city": "Frankfurt", "status": "up", "code": 200, "message": "", "time": 134, "ip": "5.6.7.8" }
    ]
  },
  "monitor": { "uuid": "…", "name": "My site", "url": "https://example.com" },
  "sent_at": "2026-06-12T10:12:03+00:00"
}`;
